import { IMSIOClient } from "@topline/services/apiService";

export class IMSIODataService {
    static componentName = "imsIODataService";
    static $inject = [IMSIOClient.componentName];

    constructor(protected imsIOClient: IMSIOClient) {}

    getLatestData(forecastId?: number) {
        return this.imsIOClient.getImsData(forecastId);
    }
}

angular.module("topline.services").service(IMSIODataService.componentName, IMSIODataService);
